<template>
  <div class="busi3-page busi-detail">
    <section class="banner">
      <h1>智慧运营服务</h1>
      <p>
        智慧运营服务核心内容是帮助客户进行配电资产的运营维护，其服务以电力安全与节电节费为主要目的，依托可视化云平台及服务大数据，融合定制化的线下解决方案，打造“平台+服务”的运营模式，为客户提供一站式智慧电力运营服务。
        <a href="https://www.wjx.cn/vm/t9gPiBR.aspx#" target="_blank">立即咨询</a>
      </p>
    </section>
    <div class="top-img" :class="scrolledTop >= 100 ? 'scrolled' : ''">
      <ul class="img1">
        <li><b>远程<br/>值守</b></li>
        <li><b>巡视<br/>维护</b></li>
        <li><b>倒闸<br/>操作</b></li>
        <li><b>预防性<br/>试验</b></li>
        <li><b>带电<br/>检测</b></li>
        <li><b>安全<br/>评估</b></li>
      </ul>
      <img class="img2" src="@/assets/b3-12.png"/>
      <ul class="img3">
        <li><b>电费<br/>规划</b></li>
        <li><b>容改需</b></li>
        <li><b>光伏<br/>建设<br/>运营</b></li>
        <li><b>预付费<br/>系统</b></li>
        <li><b>线损管<br/>理系统</b></li>
        <li><b>防窃电<br/>系统</b></li>
      </ul>
      <a href="http://esop.diannengfuwu.cn/esop-web/layout/toLogin.action" target="_blank">点击进入智慧电能运营平台</a>
    </div>
    <h2>可视化云平台为核心依托</h2>
    <p>以可视化云平台为依托，打造在线监测解决方案，在PC端和移动端为客户提供7*24h的故障实时报警、远程视频管理、用电在线监测、电能质量分析、用电智能报表及运营数据支撑等多维度的个性化定制服务，最终帮助用户实现节费节电，降低运营和人力成本投入，提升电力运营效率，减少用电安全风险隐患。</p>
    <ul class="tab ctn">
      <li :class="{c: curTab === 0}" @click="$refs.carousel0.setActiveItem(0); curTab = 0">数据采集处理</li>
      <li :class="{c: curTab === 1}" @click="$refs.carousel0.setActiveItem(1); curTab = 1">数据实时监测</li>
      <li :class="{c: curTab === 2}" @click="$refs.carousel0.setActiveItem(2); curTab = 2">告警及时推送</li>
      <li :class="{c: curTab === 3}" @click="$refs.carousel0.setActiveItem(3); curTab = 3">设备运维管理</li>
      <li :class="{c: curTab === 4}" @click="$refs.carousel0.setActiveItem(4); curTab = 4">数据统计分析</li>
    </ul>
    <el-carousel height="508px" ref="carousel0" :autoplay="false" arrow="never" indicator-position="none">
      <el-carousel-item>
        <div class="tab-content1 tab-1 ctn">
          <h3>数据采集处理</h3>
          <p>通过系统对接或智能改造采集运行数据采集数据类型超200余种边缘计算，云端处理</p>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="tab-content1 tab-2 ctn">
          <h3>数据实时监测</h3>
          <p>监测开关、表计、重要设备、视频环境等智能运维站7*24h远程监测应急</p>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="tab-content1 tab-3 ctn">
          <h3>告警及时推送</h3>
          <p>涵盖30余种告警类型，包含所有常见问题异常告警秒级推送告警内容及方式均可自定义</p>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="tab-content1 tab-4 ctn">
          <h3>设备运维管理</h3>
          <p>建立设备电子档案并定期维护档案存储云端，客户可随时调阅服务人员随时调取，提高运维抢修效率</p>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="tab-content1 tab-5 ctn">
          <h3>数据统计分析</h3>
          <p>实现对电量、负荷及其他数据统计比对分析自动生成运行统计报表，实现远程智能抄表</p>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="img-ctn ctn">
          <h2>本地化私有云平台</h2>
          <p>针对不能将运行数据接入互联网但同时对用电数据的实时监控具有迫切需求的客户，公司亦可依托私有云技术，帮助客户搭建就地电力监控系统解决方案，为用户提供用电实时监测、远程实时遥控、电能质量分析、电能统计分析、智能报表等本地化支持服务。</p>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="img-ctn ctn">
      <h2>本地化私有云平台</h2>
      <p>针对不能将运行数据接入互联网但同时对用电数据的实时监控具有迫切需求的客户，公司亦可依托私有云技术，帮助客户搭建就地电力监控系统解决方案，为用户提供用电实时监测、远程实时遥控、电能质量分析、电能统计分析、智能报表等本地化支持服务。</p>
    </div>
    <h2>配电室智能运维解决方案</h2>
    <p>为解决客户痛点，九恒特推出配电室智能运维解决方案，以云平台为支撑，以运维抢修站为支点，通过线上线下相结合的服务模式，为客户提供系统建设、线下运维及试验抢修等一条龙式的标准化运维服务，帮助客户减少运营人员数量，降低运营管理难度，在提升运行安全属性的同时，有效降低运维成本支出。</p>
    <ul class="tab">
      <li :class="{c: curImg === 0}" @click="$refs.carousel1.setActiveItem(0); curImg = 0">线上运营</li>
      <li :class="{c: curImg === 1}" @click="$refs.carousel1.setActiveItem(1); curImg = 1">线下服务</li>
    </ul>
    <el-carousel height="448px" ref="carousel1" :autoplay="false" arrow="never" indicator-position="none">
      <el-carousel-item>
        <div class="tab-content tab-1 ctn">
          <ul class="icon">
            <li><i></i>平台建设</li>
            <li><i></i>平台运营</li>
            <li><i></i>数据分析</li>
          </ul>
          <img src="@/assets/b3-5.jpg"/>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="tab-content tab-2 ctn">
          <ul class="icon">
            <li><i></i>24h远程值守</li>
            <li><i></i>巡视维护</li>
            <li><i></i>倒闸操作</li>
            <li><i></i>设备试验</li>
            <li><i></i>带电检测</li>
            <li><i></i>事故抢修</li>
            <li><i></i>安全评估</li>
          </ul>
          <img src="@/assets/b3-6.jpg"/>
        </div>
      </el-carousel-item>
    </el-carousel>
    <h2>电费节费综合解决方案</h2>
    <p>九恒凭借电力运营经验，以大数据分析为支撑，为客户进行系统化的电费成本评估，发现客户不合理的用电问题，挖掘客户潜在的节电节费点，给出针对性的节电节费措施，并执行具体的治理方案，最终为客户降低电费支出。</p>
    <ul class="img-list ctn">
      <li>
        <img src="@/assets/b3-7.jpg"/>
        <h3>全场景</h3>
        <p>覆盖电力全生命周期各场景的节费服务</p>
      </li>
      <li>
        <img src="@/assets/b3-8.jpg"/>
        <h3>低成本</h3>
        <p>无成本或微成本投入，节费效果明显</p>
      </li>
      <li>
        <img src="@/assets/b3-9.jpg"/>
        <h3>智能化</h3>
        <p>电费专业算法实现自动核算和智能化分析</p>
      </li>
    </ul>
  </div>
</template>

<script>
import {Carousel, CarouselItem} from 'element-ui'
export default {
  name: 'App',
  components: {
    ElCarousel: Carousel,
    ElCarouselItem: CarouselItem
  },
  data() {
    return {
      curTab: 0,
      curImg: 0,
      scrolledTop: 0
    }
  },
  created() {
    document.body.addEventListener('scroll', this.scrolling)
  },
  methods: {
    scrolling() {
      const s = document.body.scrollTop
      this.scrolledTop = s > this.scrolledTop ? s : this.scrolledTop
    }
  },
  destroyed() {
    document.body.removeEventListener('scroll', this.scrolling)
  }
}
</script>
